import React from "react";
import Dashboard from "./dashboard";

function App() {
  return (
    <div>
      <Dashboard />
    </div>
  );
}

export default App;
